class SwitchCollection extends HTMLElement {
    constructor() {
    super();

    this.selector = this.dataset.selector;
    this.collections = this.querySelectorAll(".child-card");

    this.initSwitch();
  }

  connectedCallback() {
    const config = {
      loop: false,
      dots: false,
      arrows: false,
      spaceBetween: 16,
      breakpoints: {
        320: {
          slidesPerView: 2.5,
        },
        750: {
          slidesPerView: 3.5,
        },
        800: {
          slidesPerView: 5,
        }
      },
    };

    new Swiper("#swiper-" + this.selector, config);
  }

  initSwitch() {
    this.collections.forEach((collection) => {
      collection.addEventListener("click", (event) => {
        event.preventDefault();
        const blockId = collection.dataset.block;
        const collectionBlocks = this.querySelectorAll(".block-collection");
        const collectionBlock = this.querySelector("#collection-" + blockId);
        collectionBlocks.forEach((block) => {
          block.classList.add("hidden");
          block.setAttribute("aria-hidden", "true");
        });
        collectionBlock.classList.remove("hidden");
        collectionBlock.setAttribute("aria-hidden", "false");
      });
    });
  }
}
customElements.define('switch-collection', SwitchCollection);